import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Stethoscope, Building2 } from "lucide-react";

export default function Services() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-600 via-emerald-500 to-cyan-400 flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-4xl backdrop-blur-xl bg-white/15 border border-white/20 rounded-3xl shadow-2xl overflow-hidden">
        
        {/* Header */}
        <div className="px-6 sm:px-10 py-10 text-center border-b border-white/10">
          <div className="flex justify-center mb-4">
            <div className="bg-white/20 p-4 rounded-full shadow-lg">
              <Stethoscope className="w-10 h-10 text-white" />
            </div>
          </div>

          <h1 className="text-4xl sm:text-5xl font-extrabold text-white tracking-tight">
            Our Services
          </h1>

          <p className="mt-3 text-white/80 text-sm sm:text-base max-w-2xl mx-auto">
            Smart AI-powered healthcare assistance designed to make healthcare
            guidance simple, accessible, and affordable.
          </p>
        </div>

        {/* Main Content */}
        <div className="px-6 sm:px-10 py-8 text-white">
          <div className="space-y-6">
            
            {/* Service Card */}
            <div className="bg-white/10 border border-white/10 rounded-2xl p-6 shadow-lg hover:bg-white/15 transition duration-300">
              <div className="flex items-start gap-4">
                <div className="bg-white/20 p-3 rounded-xl">
                  <Stethoscope className="w-6 h-6 text-white" />
                </div>

                <div>
                  <h2 className="text-xl font-semibold mb-2">
                    AI Powered Care Assistant
                  </h2>

                  <p className="text-white/90 leading-relaxed text-sm sm:text-base">
                    AICA provides intelligent healthcare assistance powered by
                    AI, helping users access smart care solutions at affordable
                    pricing starting from{" "}
                    <span className="font-bold text-white">
                      Rs 99/- onwards
                    </span>.
                  </p>
                </div>
              </div>
            </div>

            {/* Billing Card */}
            <div className="bg-white/10 border border-white/10 rounded-2xl p-6 shadow-lg hover:bg-white/15 transition duration-300">
              <div className="flex items-start gap-4">
                <div className="bg-white/20 p-3 rounded-xl">
                  <Building2 className="w-6 h-6 text-white" />
                </div>

                <div>
                  <h2 className="text-xl font-semibold mb-2">
                    Billing Information
                  </h2>

                  <p className="text-white/90 leading-relaxed text-sm sm:text-base">
                    AICA HEALTH TECH Pvt Ltd <br />
                    1st Floor, D-48, Ajay Enclave, <br />
                    New Delhi - 110018
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Footer Actions */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-10">
            <p className="text-sm text-white/70 text-center sm:text-left">
              Powered by <span className="font-semibold">AICA</span> | Your
              Smart Health Assistant
            </p>

            <button
              onClick={() => navigate("/")}
              className="group flex items-center gap-2 bg-white text-teal-700 font-semibold px-5 py-3 rounded-xl shadow-lg hover:scale-105 hover:bg-gray-100 transition-all duration-300"
            >
              <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
              Back to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}